module.exports = __webpack_public_path__ + "img/triangle.7f3bb9db.svg";